import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-primary" }, "ノート", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "これまでの研究で使用したメモやコードなどを置きます．", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoteList = _resolveComponent("NoteList")!
  const _component_ProgramList = _resolveComponent("ProgramList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_NoteList),
      _createVNode(_component_ProgramList)
    ])
  ]))
}